'use strict';

module.exports = function (element, message, expTime, addCloseBtn, customClass) {
    if (addCloseBtn) {
        $(element).empty().append(`
            <div
                class="alert alert-success alert-dismissible fade show ${customClass ? customClass : ''}"
                role="alert"
            >
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                ${message}
            </div>
        `);
    } else {
        $(element).empty().append(`
        <div
            class="alert alert-success alert-dismissible fade show ${customClass ? customClass : ''}"
            role="alert"
        >
            ${message}
        </div>
    `);
    }

    if (expTime) {
        setTimeout(() => { $(element).empty(); }, expTime);
    }
};
